import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import { AuthContext, TourContextProvider, PatientsContextProvider } from "./Contexts";

import { Login, Patients } from "./Views";

export const AppRouter = () => {
  const authContext = useContext(AuthContext);

  if (authContext.loading) {
    return <div>Loading...</div>;
  }

  if (!authContext.user) {
    return <Login />;
  }

  return (
    <div>
      <Router>
        <Switch>
          <Redirect exact from="/" to="/patient" />
          <Route path="/patient/:id?" component={Patients} />
        </Switch>
      </Router>
    </div>
  );
};
